<template>
    <div class="spotlight-widget spotlight-math-widget" @click="copyResult">
        <div class="spotlight-widget-icon spotlight-widget-icon--math">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="8.01" y2="10"/><line x1="12" y1="10" x2="12.01" y2="10"/><line x1="16" y1="10" x2="16.01" y2="10"/><line x1="8" y1="14" x2="8.01" y2="14"/><line x1="12" y1="14" x2="12.01" y2="14"/><line x1="16" y1="14" x2="16.01" y2="14"/><line x1="8" y1="18" x2="8.01" y2="18"/><line x1="12" y1="18" x2="16" y2="18"/></svg>
        </div>
        <div class="spotlight-widget-content">
            <div class="spotlight-widget-result"><span class="spotlight-widget-eq">=</span> {{ formattedResult }}</div>
            <div class="spotlight-widget-expression">{{ data.expression }}</div>
        </div>
        <div v-if="copied" class="spotlight-widget-copied">{{ $t('common.spotlight.copied') }}</div>
    </div>
</template>

<script>
export default {
    name: 'MathCalculator',
    props: {
        data: { type: Object, required: true }
    },
    data() {
        return { copied: false }
    },
    computed: {
        formattedResult() {
            const val = this.data.result
            if (Number.isInteger(val)) return val.toLocaleString('tr-TR')
            return val.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 6 })
        }
    },
    methods: {
        async copyResult() {
            try {
                await navigator.clipboard.writeText(String(this.data.result))
                this.copied = true
                setTimeout(() => { this.copied = false }, 1500)
            } catch (e) { void e }
        }
    }
}
</script>
